// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O8ygA","label":"styles_label__3fi9S"};